import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import resourceService from './resourceService'


const initialState = {
    resources: [],
    resourceCreatedStatus: false,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

// Create new resource

export const createResources = createAsyncThunk('resources/create', async (formData, thunkAPI) => {

    try {
        // const token = thunkAPI.getState().auth.user.accessToken;
        const token = thunkAPI.getState().auth.user.token;
        return await resourceService.createResources(formData, token);
    } catch (error) {
        const message  = (error?.response && error?.response?.data && error?.response?.data?.message) || error?.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
});

// Edit resource

export const editResource = createAsyncThunk('resources/edit', async (formData, thunkAPI) => {

    try {
        // const token = thunkAPI.getState().auth.user.accessToken;
        const token = thunkAPI.getState().auth.user.token;
        return await resourceService.editResource(formData, token);
    } catch (error) {
        const message  = (error?.response && error?.response?.data && error?.response?.data?.message) || error?.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
});

//Get internal resources

export const getResources = createAsyncThunk('resources/getAll', async (_, thunkAPI) => {
    
        try {
            const token = thunkAPI.getState().auth.user.token;
            return await resourceService.getResources(token);
        } catch (error) {
            const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
            return thunkAPI.rejectWithValue(message);
        }
})

export const getAllResources = createAsyncThunk('allresources/getAll', async (_, thunkAPI) => {
    
    try {
        const token = thunkAPI.getState().auth.user.token;
        return await resourceService.getAllResources(token);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
})


//Get getResourceByNLNCode

export const getResourceByNLN = createAsyncThunk('getsingleresource/resource', async (resourceNlnCode, thunkAPI) => {
    
    try {
        // const token = thunkAPI.getState().auth.user.token;
        return await resourceService.getResourceByNLN(resourceNlnCode);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
})


//Delete resource category

export const deleteResources = createAsyncThunk('resources/delete', async (resourceId, thunkAPI) => {

    try {
        // const token = thunkAPI.getState().auth.user.accessToken;
        const token = thunkAPI.getState().auth.user.token;
        return await resourceService.deleteResources(resourceId, token);
    } catch (error) {
        const message  = (error?.response && error?.response?.data && error?.response?.data?.message) || error?.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
});


export const resourcesSlice = createSlice({
    name: "resources",
    initialState,
    reducers: {
        reset: (state) => initialState 
    },
    extraReducers: (builder) => {
        builder
        .addCase(createResources.pending, (state) => {
            state.isLoading = true;
    })
        .addCase(createResources.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.resourceCreatedStatus = !state.resourceCreatedStatus
            // state.resources.push(action.payload);
    })

    .addCase(createResources.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // console.log(action.payload);
        
    })
    .addCase(getResources.pending, (state) => {
        state.isLoading = true;
})
    .addCase(getResources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.resources = action?.payload?.data.results
        // state.resources = action.payload
})

.addCase(getResources.rejected, (state, action) => {
    state.isLoading = false;
    state.isError = true;
    state.message = action.payload;
    console.log(action.payload);
    
})

    .addCase(getAllResources.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getAllResources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.resources = action?.payload?.data.results
        // state.resources = action.payload
    })

    .addCase(getAllResources.rejected, (state, action) => {
    state.isLoading = false;
    state.isError = true;
    state.message = action.payload;

    })

    .addCase(getResourceByNLN.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getResourceByNLN.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.resources = state.resources.find((resources) => resources === action?.payload.data.foundResource.resourceNlnCode )
        // state.resources = action?.payload?.data.foundResource
        // state.resources = action.payload
    })

    .addCase(getResourceByNLN.rejected, (state, action) => {
    state.isLoading = false;
    state.isError = true;
    state.message = action.payload;

    })

.addCase(deleteResources.pending, (state) => {
    state.isLoading = true;
    })
    .addCase(deleteResources.fulfilled, (state, action) => {
    state.isLoading = false;
    state.isSuccess = true;
    state.resources = state.resources.filter((resource) => resource?.resourceId !== action.payload.resourceId )
    // state.resources = state.resourceTag.filter((resource) => resource._id !== action.payload.id )
    })

    .addCase(deleteResources.rejected, (state, action) => {
    state.isLoading = false;
    state.isError = true;
    state.message = action.payload;
    }) 
}

}) 

// export const singleResourceByNLN = (state, action) => state.resources.find((resources) => resources === action?.payload?.data?.foundResource?.resourceNlnCode )

export const {reset} = resourcesSlice.actions;
export default resourcesSlice.reducer;